let routerNavigate: ((path: string) => void) | null = null;


// Trigger navigation (used by the other app)
export const navigate = (path: string) => {
  (window?.parent ?? window).postMessage({ type: 'ROUTE_CHANGE', path: path }, '*');
};
